import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, Moon, AlertTriangle } from "lucide-react";
import { getDreGerencial } from "../../api";
import SideBarNavGestaoOrcamentaria from "../../componets/SideBarNavGestaoOrcamentaria";
import DreGerencialView from "../../components/gestaoOrcamentaria/DreGerencialView";
import DreGerencialAcumuladoView from "../../components/gestaoOrcamentaria/DreGerencialAcumuladoView";

// DRE Gerencial: consolidador 100% somente leitura — nenhum formulário de cadastro aqui,
// tudo vem agregado dos módulos de origem (ver backend/services/dre_gerencial_svc.py).
// Único filtro é o Ano; não há seletor de empresa nesta fase (a maioria dos módulos de
// origem ainda não tem essa dimensão).

const palette = (isLight) => ({
  bg: isLight ? "#F8F7FC" : "#0F0A1E",
  card: isLight ? "#FFFFFF" : "#1A1030",
  border: isLight ? "#E5E0F0" : "#2E2050",
  text: isLight ? "#1A1030" : "#EDE9FA",
  muted: isLight ? "#7C6FA0" : "#9585C0",
  brand: "#7C3AED",
  bgActive: isLight ? "#F1E9FE" : "#241A3D",
  categoriaBg: isLight ? "#EDE0FB" : "#251A45",
  subcategoriaBg: isLight ? "#F5F0FC" : "#1E1435",
  margemBg: isLight ? "#FEF3E2" : "#2E2210",
  success: "#10B981",
  danger: "#EF4444",
});

const ANO_ATUAL = new Date().getFullYear();
const OPCOES_ANO = Array.from({ length: ANO_ATUAL + 2 - 2025 + 1 }, (_, i) => 2025 + i);

export default function DreGerencial() {
  const [isLight, setIsLight] = useState(true);
  const C = palette(isLight);
  const navigate = useNavigate();

  const [ano, setAno] = useState(ANO_ATUAL+1);
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    let cancelado = false;
    setLoading(true);
    setErro("");
    getDreGerencial(ano)
      .then((resposta) => { if (!cancelado) setDados(resposta); })
      .catch((e) => { if (!cancelado) setErro(e.message); })
      .finally(() => { if (!cancelado) setLoading(false); });
    return () => { cancelado = true; };
  }, [ano]);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: C.bg, fontFamily: "'DM Sans', sans-serif", color: C.text }}>
      <SideBarNavGestaoOrcamentaria isLight={isLight} />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto" }}>
        <header style={{
          background: "linear-gradient(90deg, #4c1d95 0%, #9d174d 100%)",
          color: "#fff", padding: "14px 24px",
          display: "flex", justifyContent: "space-between", alignItems: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 22, fontWeight: 800 }}>YOUX</span>
            <span style={{ fontSize: 18, fontWeight: 300 }}>GROUP</span>
            <span style={{ fontSize: 13, fontWeight: 500, opacity: 0.8, marginLeft: 8 }}>· DRE Gerencial</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <select
              value={ano}
              onChange={(e) => setAno(parseInt(e.target.value, 10))}
              style={{ background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 8, padding: "7px 10px", color: "#fff", fontSize: 13, fontWeight: 600 }}
            >
              {OPCOES_ANO.map((a) => <option key={a} value={a} style={{ color: "#0F172A" }}>{a}</option>)}
            </select>
            <button onClick={() => setIsLight((l) => !l)} style={{
              display: "flex", alignItems: "center", gap: 6,
              background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.25)",
              borderRadius: 8, padding: "7px 12px", cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 600,
            }}>
              {isLight ? <Sun size={14} /> : <Moon size={14} />}
              {isLight ? "Tema Claro" : "Tema Escuro"}
            </button>
            <button
              onClick={() => navigate("/inicio")}
              style={{ display: "flex", alignItems: "center", gap: 6, background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.25)", borderRadius: 8, padding: "7px 14px", cursor: "pointer", color: "#fff", fontSize: 13, fontWeight: 600 }}
            >
              Menu Principal
            </button>
          </div>
        </header>

        <main style={{ padding: 24, display: "flex", flexDirection: "column", gap: 24 }}>
          {erro && (
            <div style={{
              display: "flex", alignItems: "center", gap: 8, background: `${C.danger}18`,
              border: `1px solid ${C.danger}`, color: C.danger, borderRadius: 10, padding: "10px 14px", fontSize: 13,
            }}>
              <AlertTriangle size={16} /> {erro}
            </div>
          )}

          {loading ? (
            <div style={{ padding: 48, textAlign: "center", color: C.muted, fontSize: 13 }}>Carregando…</div>
          ) : (
            dados && (
              <>
                <DreGerencialView data={dados} ano={ano} C={C} />
                <DreGerencialAcumuladoView ano={ano} C={C} />
              </>
            )
          )}
        </main>
      </div>
    </div>
  );
}
